import React from 'react'

import { ServerBanner } from '@/components/common/Banner'
import Link from '@/components/common/Link'
import { SweetspotMarkLoading } from '@/components/common/SweetspotMarkLoading'

interface LoadingScreenProps {
  showRedirectToOnboardingButton?: boolean
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  showRedirectToOnboardingButton = false,
}) => {
  return (
    <div className="flex flex-col items-center justify-between w-screen h-screen">
      <ServerBanner />
      <div className="flex items-center justify-center w-full h-full">
        {showRedirectToOnboardingButton ? (
          <span className="text-center text-sm font-medium text-primary-900 dark:text-primary-100 px-8">
            Looks like you&apos;re new here.{' '}
            <Link href="/welcome">Click here</Link> to get started.
          </span>
        ) : (
          <div role="status" className="flex items-center">
            <SweetspotMarkLoading size={48} />
            <img
              src="/sweetspot-wordmark-v2-nologo.svg"
              alt=""
              aria-hidden
              width={2407}
              height={512}
              className="ml-4 h-12 w-auto"
              draggable={false}
            />
            <span className="sr-only">Loading</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default LoadingScreen
